import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import CCC from '../CCC'

export default function LayoutCCC() {
    return (
        <div>
            <Header />
            <CCC />
            <Footer />
        </div>
    )
}
